//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { generateComputed } from '../../../../common/functions/roles-computed-generator';
import CRUDGenerico from '../../../../shared-components/generico/CRUDGenerico';
import EstruturaForm from './EstruturaForm';
import EstruturaTabela from './EstruturaTabela';

export default {
  name: 'EstruturaCadastro',
  extends: CRUDGenerico,
  data() {
    return {
      estruturaUsuarioResources: this.$api.estruturaUsuario(this.$resource),
    };
  },
  components: {
    EstruturaForm,
    EstruturaTabela,
  },
  computed: {
    ...generateComputed('Estrutura', [
      'canAccessCRUD',
      'canAccessPage',
    ]),
    somenteLeitura() {
      return !this.canAccessCRUD;
    },
  },
  methods: {
    onEditarEstrutura(estrutura) {
      this.$refs.formularioCadastroDeDivisao.editar(estrutura);
      this.$refs.dialogoFormularioCadastroDeDivisao.editar(estrutura);
      this.$refs.dialog1.open();
    },
    onNovaEstrutura() {
      this.$refs.tabelaEstruturaUsuario.filtrar();
      if (this.$refs.dialog1) {
        this.$refs.dialog1.close();
      }
    },
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
  },
  beforeMount() {
    if (!this.canAccessPage) {
      window.setTimeout(() => {
        this.accessForbidden();
      }, 1E3);
    }
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/estrutura-usuario/EstruturaCadastro.vue?vue&type=script&lang=js&